type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const RightArrowIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.93945 11.8229H17.7619M17.7619 11.8229L11.3507 5.41162M17.7619 11.8229L11.3507 18.2341"
        stroke={color}
        strokeWidth="1.83178"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
